import React, { Component } from 'react';
import './index.styl';
import DeviceTree from './DeviceTree';
import Digital from './Digital';
import Chart from './Chart';
import Map from './Map';
import { getInfo, getDevices } from './request/dao';

const clzpre = 'ssfe-environment';
const tabs = [
    { name: '数值显示', key: 'digital' },
    { name: '仪表显示', key: 'chart' },
    { name: '实时地图', key: 'map' }
];

class Environment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: 'digital',
            current: ''
        };
        getDevices().then(d => {
            if (d.length) {
                const id = d[0].id;
                getInfo(d[0].id);
                this.setState({
                    current: id
                });
            }
        });
    }

    setTab = tab => this.setState({ tab });

    onNodeClick = d => {
        getInfo(d.id);
        this.setState({ current: d.id });
    };

    getTabDom = () =>
        tabs.map(tab => (
            <span
                key={tab.key}
                className={this.state.tab === tab.key ? 'active' : ''}
                onClick={() => this.setTab(tab.key)}
            >
                {tab.name}
            </span>
        ));

    getPanelDom = () => {
        switch (this.state.tab) {
            case 'chart':
                return <Chart />;
            case 'map':
                return <Map current={this.state.current} />;
            case 'digital':
            default:
                return <Digital />;
        }
    };

    render() {
        return (
            <div className={clzpre}>
                <DeviceTree onNodeClick={this.onNodeClick} current={this.state.current} />
                <article>
                    <p>{this.getTabDom()}</p>
                    <section>{this.getPanelDom()}</section>
                </article>
            </div>
        );
    }
}

export default Environment;
